import React,{useState} from 'react'
import Canvas from "../canvas/Canvas"

import thumb1 from '../images/thumb_01.jpg';
import thumb2 from '../images/thumb_02.jpg';
import thumb3 from '../images/thumb_03.jpg';
import thumb4 from '../images/thumb_04.jpg';

import img1 from '../images/1.png';
import img2 from '../images/2.png';
import img3 from '../images/3.png';
import img4 from '../images/4.png';

import {Modal} from 'react-bootstrap';
import "./modal.css";

export default function EyeLids(){
    const [show,setShow] = useState(false);
   const [title,setTitle] = useState("Eye Lids");
   const [showImage,setShowImage] = useState(img1);

   const handleShow = (subtitle,imagename)=>{
        setTitle(subtitle)
        setShowImage(imagename)
        setShow(true)
   }
    return(
        <>
           <div className="card card-custom gutter-b">
                <div className="card-header">
                    <div className="card-title">
                        <h3 className="card-lable">
                            Eye Lids
                        </h3>
                    </div>
                </div>
                <div className="card-body">
                    <div className="row">

                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb1}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Lids 3/4</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Eye Lids - Lids 3/4",img1)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 
                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb2}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Lids Front</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Eye Lids - Lids Front",img2)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 


                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img alt="excimage"  src={thumb3}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Lids Profile</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Eye Lids - Lids Profile",img3)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 


                        <div className="col-lg-2">
                            <div className="card card-custom overlay">
                                <div className="card-body p-0">
                                    <div className="overlay-wrapper">
                                    <img src={thumb4}  className="w-100 rounded" />
                                    <h6 className="text-muted ml-2 mt-2">Lids Closeup</h6>
                                    </div>
                                    <div className="overlay-layer">
                                        <button className="btn font-weight-bold btn-primary btn-shadow" onClick={()=>handleShow("Eye Lids - Lids Closeup",img4)}>Draw</button>
                                    </div>
                                </div>
                            </div>
                        </div> 


                    </div>
                </div>
            </div> 

            <Modal
                show={show}
                size="lg"
                onHide={()=>setShow(false)}
                dialogClassName="modal-90w"
                >
                    <Modal.Header closeButton>
                      
                        <Modal.Title>
                            Eye Draw - {title}
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>     
                      {/*   <Image src={img1} fluid />*/}
                      <div style={{height:"70vh",width:"60vw"}}>
                      <Canvas image={showImage} />
                      </div>
                     
                    </Modal.Body>
                </Modal>
        </>
    )
}